module.exports = __webpack_public_path__ + "img/saleskintabi.6e696b89.png";